import { useEffect, usePersistedUserData } from 'src/hooks'
import { useValidateEmail } from 'src/react_query'
import { parseError } from 'src/utils/parseError'

const rfc5322EmailRegex =
  /([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|"(!#-[^-~ \t]|(\\[\t -~]))+")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)+|\[[\t -Z^-~]*])/

const useEmailValidation = (email: string) => {
  const { isLoading, mutateAsync, error, data, status } = useValidateEmail()
  const { account } = usePersistedUserData()

  const isCurrentUser = account && email === account.email
  const isFormatValid = rfc5322EmailRegex.test(email)

  useEffect(() => {
    if (email && isFormatValid && !isCurrentUser) {
      ;(async () => {
        await mutateAsync({
          email,
        })
      })()
    }
  }, [email, isFormatValid, isCurrentUser, mutateAsync])

  const getErrorMessage = () => {
    if (isCurrentUser) return undefined
    if (!isFormatValid && email) {
      return 'Email format is invalid. Please enter a valid email address to continue.'
    }
    if (data?.errorMsg) return data.errorMsg
    if (status === 'error') {
      return parseError(error, 'Failed to validate email')
    }
    return undefined
  }

  return {
    errorMessage: getErrorMessage(),
    hasPerformedValidation: status === 'success',
    isLoading,
    isValid: isCurrentUser ? true : isFormatValid && (data?.isValid ?? false),
  }
}

export default useEmailValidation
